import { get, set, cloneDeep, unset } from 'lodash-es';
import {
  ResetShiftTypeRequestBody,
  ResourcesWithShifts,
  BaseResource,
  BaseShift,
  ShiftType,
  ResourceShiftTypeHrSystemConflict,
} from '@/api/apis/resources/schedule';

export const getSchedulerShiftItemUpdater =
  <S extends BaseShift<string>>({ day, ...payload }: S) =>
  <R extends BaseResource>(data?: ResourcesWithShifts<R, S>): ResourcesWithShifts<R, S> | undefined => {
    if (data) {
      const cloned = cloneDeep(data);
      const path = [payload.resourceId, 'days', day];
      const shift: S = get(cloned, path);
      const updated: S = { ...shift, ...payload };

      set(cloned, path, updated);

      return cloned;
    }
    return undefined;
  };

export const getSchedulerShiftItemRemover =
  ({ day, resourceId }: ResetShiftTypeRequestBody) =>
  <R extends BaseResource, S extends BaseShift<string>>(
    data?: ResourcesWithShifts<R, S>,
  ): ResourcesWithShifts<R, S> | undefined => {
    if (!data) return undefined;

    const cloned = cloneDeep(data);
    const path = [resourceId, 'days', day];

    unset(cloned, path);

    return cloned;
  };

export const getHrSystemConflictItemRemover =
  (conflictId: string) =>
  <R extends BaseResource, T extends ShiftType>(
    data?: ResourceShiftTypeHrSystemConflict<R, T>[],
  ): ResourceShiftTypeHrSystemConflict<R, T>[] | undefined => {
    if (!data) return undefined;

    return data.filter((c) => c.conflictId !== conflictId);
  };
